import { useQuery, UseQueryOptions } from "@tanstack/react-query"
import { AxiosError, AxiosInstance } from "axios"

import { API_DEFAULT } from "src/constants/minutApi"
import {
  profilesCache,
  TProfileItemCache,
} from "src/data/homeProfiles/queries/homeProfilesCache"
import { IProfileResponse } from "src/data/homeProfiles/types/homeProfilesTypes"
import { minutApiHttpClient } from "src/utils/minutApiHttpClient"

const client: AxiosInstance = minutApiHttpClient
const profilesUrl = `${API_DEFAULT}/profiles`

export function useFetchProfile<Select = IProfileResponse>(props: {
  id: string
  options?: UseQueryOptions<
    IProfileResponse,
    AxiosError,
    Select,
    TProfileItemCache
  >
}) {
  const { id, options } = props || {}
  async function fetchProfile(id: string): Promise<IProfileResponse> {
    const response = await client.get(`${profilesUrl}/${id}`)
    return response.data
  }

  return useQuery(profilesCache.item(id), () => fetchProfile(id), {
    ...options,
  })
}
